import { createFeatureSelector } from '@ngrx/store';
import * as fromCompanies from '../reducer/user-companies.reducer';

export const getUserCompaniesState = createFeatureSelector<fromCompanies.State>('userCompanies');

const { selectAll } = fromCompanies.userCompaniesAdapter.getSelectors(getUserCompaniesState);

export const selectAllUserCompanies = selectAll;
